import jsPDF from 'jspdf';
import { A4_SHEET_FORMAT, LANDSCAPE_ORIENTATION, MILLIMETERS_MEASUREMENT_UNIT, ONE_PAGER_REPORT_KEY } from '../Constants/ProjectReportConstants';
import { generatePageInPDF } from '../Helpers/CreatePDFHelper';
import { cleanupContainer, createOffscreenContainer } from '../Helpers/ContainerHelper';
import { ONE_PAGER_CONFIG } from '../Config/OnePagerConfig';

interface generatePdfProjectReportProps {
    data: any;
    onLoading: (loading: boolean) => void;
}

export const generatePdfOnePagerProjectReport = async ({ data, onLoading }: generatePdfProjectReportProps) => {
    try {
        onLoading?.(true);

        const container = createOffscreenContainer();
        const pdf = new jsPDF(LANDSCAPE_ORIENTATION, MILLIMETERS_MEASUREMENT_UNIT, A4_SHEET_FORMAT);

        const productType = data?.projectProductType;
        const productClassification = data?.projectProductTypeClassification;

        if (productType === undefined || productClassification === undefined) {
            throw new Error("Missing required fields in data, aborting PDF generation.");
        }

        data.typeReport = ONE_PAGER_REPORT_KEY;

        const pageToRender = ONE_PAGER_CONFIG.find(cfg => cfg.condition(productType, productClassification));

        if (!pageToRender) {
            throw new Error("No matching page found for given product type/classification.");
        }

        await generatePageInPDF(data, pdf, container, pageToRender.component);

        pdf.deletePage(pdf.getNumberOfPages());
        pdf.save(`${ONE_PAGER_REPORT_KEY}-${data.code}.pdf`);

        cleanupContainer(container);
    } catch (error) {
        throw new Error("Error generating PDF: " + error);
    } finally {
        onLoading?.(false);
    }
};

export const generatePdfOnePagerProjectReportBlob = async ({ data, onLoading }: generatePdfProjectReportProps) => {
    let container: HTMLDivElement | null = null;
    try {
        onLoading?.(true);
        console.log('[OnePagerBlob] Start generation', {
            projectId: data?.id,
            code: data?.code,
            productType: data?.projectProductType,
            productClassification: data?.projectProductTypeClassification,
        });

        container = createOffscreenContainer();
        const pdf = new jsPDF(LANDSCAPE_ORIENTATION, MILLIMETERS_MEASUREMENT_UNIT, A4_SHEET_FORMAT);

        const productType = data?.projectProductType;
        const productClassification = data?.projectProductTypeClassification;

        if (productType === undefined || productClassification === undefined) {
            cleanupContainer(container);
            throw new Error("Missing required fields in data, aborting PDF generation.");
        }

        data.typeReport = ONE_PAGER_REPORT_KEY;

        const pageToRender = ONE_PAGER_CONFIG.find(cfg => cfg.condition(productType, productClassification));

        if (!pageToRender) {
            cleanupContainer(container);
            throw new Error("No matching page found for given product type/classification.");
        }

        await generatePageInPDF(data, pdf, container, pageToRender.component);

        pdf.deletePage(pdf.getNumberOfPages());
        const blob = pdf.output('blob');
        const filename = `${ONE_PAGER_REPORT_KEY}-${data.code}.pdf`;

        return { blob, filename };
    } catch (error) {
        throw new Error("Error generating PDF: " + error);
    } finally {
        if (container) {
            cleanupContainer(container);
        }
        onLoading?.(false);
    }
};
